import axios from '@apis/spring-client';
import { GetUserInterestInfoData } from 'models/swagger-spring/data-contracts';
import { useQuery } from 'react-query';

export const getUserInterestInfo = async (): Promise<GetUserInterestInfoData> => {
  try {
    const response = await axios.get('/api/user/interest-info');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const useGetUserInterestInfo = () => {
  return useQuery(['getUserInterestInfo'], () => getUserInterestInfo());
};

export default useGetUserInterestInfo;
